import { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'

import SideNav from 'components/side-nav'
import * as blUrls from 'lib/urls'
import HelloBabyMeta from 'hello_baby/components/HelloBabyMeta/HelloBabyMeta'
import { filterPostsByTopicSlug } from '../../lib'
import PostCardRow from '../post-card-row'
import HeroPost from '../HeroPost'
import TopicSection from '../TopicSection'

import css from './LandingPage.styles.scss'

import { FEATURED_POSTS_COLLECTION_SLUG } from '../../constants'

import { maybeFetchPosts } from '../../actions'
import { SectionHeading } from '../../../components/headings'

import { useDispatch, useSelector } from 'react-redux'

interface LandingPageProps {
  topicNavigation: {
    items: [
      {
        name: string
        slug: string
        children: [
          {
            name: string
            slug: string
          },
        ]
      },
    ]
  }
  homeTopics: any
}

const LandingPage = ({ topicNavigation, homeTopics }: LandingPageProps) => {
  const dispatch = useDispatch()
  const state = useSelector((state) => state as any)
  const getState = () => state

  const { posts } = state
  const navCategory = { title: 'Home', path: '/hello-baby', urlSlug: null }
  const sideNavTree = topicNavigation.items.map((topic) => {
    return {
      title: topic.name,
      urlSlug: topic.slug,
      children: topic.children.map((child) => {
        return {
          title: child.name,
          urlSlug: child.slug,
          path: blUrls.helloBabyPostPath(child.slug),
        }
      }),
      path: blUrls.helloBabyPostPath(topic.slug),
    }
  })

  const featuredPosts = state.collections[
    FEATURED_POSTS_COLLECTION_SLUG
  ].itemIds
    .slice(0, 5)
    .map((id: string) => posts[id])

  useEffect(() => {
    maybeFetchPosts(featuredPosts.map((post: any) => post.id))(
      dispatch,
      getState
    )
  }, [])

  return (
    <>
      <HelloBabyMeta
        canonical={blUrls.babylistUrl(blUrls.helloBabyPath)}
        seoDescription="Find advice, tips, and product reviews to help you handle pregnancy and early parenting. Hello Baby makes parenting easier."
        keywords="baby product reviews, baby names, pregnancy tips, parenting advice, strollers, diapers, car seats, babies"
        title="Hello Baby by Babylist - Pregnancy and Parenting Advice"
      />
      <div className="container mtm pts ptn-sm mtxl-sm">
        <div className="visible-xs">
          <SectionHeading className="h3 mvm">Featured Guides</SectionHeading>
          <hr className="mtm mbl" />
        </div>
        <HeroPost post={featuredPosts[0]} />
        <PostCardRow
          showTopics
          className="mtxl"
          columns={4}
          posts={featuredPosts.slice(1, 5)}
        />

        <Row className="mvl">
          <Col className={classNames(css.sideNavContainer, 'hidden-xs')} sm={3}>
            <SideNav
              categoryTree={sideNavTree}
              navCategory={navCategory}
              sidebarTitle="Guides"
            />
          </Col>
          <Col className="mtl" sm={9}>
            <div className={css.landingContainer}>
              {(homeTopics?.items || [])
                .map((topic: any) => {
                  const topicPosts = filterPostsByTopicSlug(
                    posts,
                    topic.slug
                  ).slice(0, 5)
                  if (topicPosts && topicPosts.length) {
                    return (
                      <TopicSection
                        hideLastPostSm
                        key={`topic_section_${topic.slug}`}
                        posts={topicPosts}
                        showTopics={false}
                        topic={{ name: topic.name, slug: topic.slug }}
                      />
                    )
                  }

                  return null
                })
                .filter((topicSection: any) => topicSection)}
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default LandingPage
